<script>
/**
 * 排出事業者データ補完
 */
import EmissionSearchModal from "./EmissionSearchModal.vue";
import EmissionAddModal from "./EmissionAddModal.vue";
import {mapActions} from "vuex";

export default {
  name: "EmissionComplementModal",
  components: {
    EmissionSearchModal,
    EmissionAddModal
  },
  props: {
    /**
     * 本ダイアログ表示制御
     */
    dialog: {
      type: Boolean,
      default: () => false
    },
    /**
     * JWNETマニフェスト一覧で選択されたマニフェストID
     */
    selectableIds: {
      type: Array,
      default: () => []
    },
    /**
     * JWNETマニフェスト一覧検索結果表示日時
     */
    searchedAt: {
      type: Number,
      default: () => null,
    },
  },
  watch: {
    dialog(val) {
      this.transferManifests = [];
      this.selectableId = null;
      this.selectableItem = null;
      if (val) {
        this.transferManifestSearch();
      }
    }
  },
  data() {
    return {
      /* 紐付けボタン押下にて表示するモーダルの表示制御 */
      searchEmission: false,
      /* 新規登録ボタン押下にて表示するモーダルの表示制御 */
      addEmission: false,
      /* 一覧のヘッダー情報 */
      tableHeader: [
        { text: 'マニフェスト', value: 'manifest_no', sortable: false, align: "center" },
        { text: '加入者番号', value: 'jwnet_emission_subscriber_number', sortable: false },
        { text: '排出事業者名\r\n住所', value: 'jwnet_emission', sortable: false },
        { text: '排出事業場名\r\n事業場住所', value: 'jwnet_location', sortable: false },
        { text: 'DXE事業者コード\r\nDXE加入者番号', value: 'dxe_emission_code', sortable: false },
        { text: 'DXE排出事業者名\r\nDXE住所', value: 'dxe_emission', sortable: false },
        { text: "", value: "actions", sortable: false, align: "end" }
      ],
      /* 一覧情報 */
      transferManifests: [],
      /* 紐付けモーダルに受け渡す「加入者番号未登録を含める」の制御フラグ */
      notExistSameNumber: false,
      /* 紐付け・新規登録ボタンを押下した行のJWNETマニフェストID */
      selectableId: null,
      /* 紐付け・新規登録ボタンを押下した行のJWNETマニフェスト */
      selectableItem: null,
    }
  },
  methods: {
    ...mapActions("DriverTransferEmissionComplement", {
      fetchTransferManifest: "index",
    }),
    ...mapActions("DriverTransferEmission", {
      fetchEmissions: "index",
    }),

    /**
     * 紐付けボタン クリックイベント
     * 排出事業者の紐付けモーダルを表示する.
     */
    selectButtonClickEvent (item) {
      this.selectableItem = item;

      const params = {
        page: 1,
        subscriber_number: item.jwnet_emission_subscriber_number,
      };
      this.fetchEmissions({params: params}).then((content) => {
        this.notExistSameNumber = content.emissions.length <= 0;
        this.searchEmission = true;
      });


    },
    /**
     * 新規登録ボタン クリックイベント
     * 排出事業者の新規登録モーダルを表示する.
     */
    addButtonClickEvent (item) {
      this.selectableId = item.id;
      this.addEmission = true;
    },
    /**
     * 閉じるボタン クリックイベント
     * 閉じることを呼び出し元に伝達.
     */
    closeButtonClickEvent () {
      this.$emit('closeCallback')
    },
    /**
     * モーダルからコールバック
     * 本モーダルから立ち上げたモーダルを閉じる
     */
    closeModalCallback () {
      this.searchEmission = false;
      this.addEmission = false;
    },
    /**
     * 各モーダルにて登録後のコールバック処理
     * 本モーダル一覧の再検索、呼び出し元一覧の再検索を行い、選択・新規のモーダルを閉じる
     */
    emissionSearchCallback () {
      this.transferManifestSearch();
      this.$emit("registerCallback");
      this.closeModalCallback();
    },
    /**
     * 排出事業者データ補完一覧の検索
     */
    transferManifestSearch () {
      this.fetchTransferManifest({ params: { jwnet_manifest_ids: this.selectableIds.join(',') } }).then((content) => {
        this.transferManifests = content.transfer_manifests
      })
    },
  }
}
</script>

<template>
  <div>
    <v-dialog
      :value="dialog"
      scrollable
      width="1500"
      @click:outside="closeButtonClickEvent"
      @close="closeButtonClickEvent"
      @keydown.esc="closeButtonClickEvent"
    >
      <v-card>
        <v-toolbar
          color="primary"
          dark
          flat
        >
          <v-toolbar-title>
            排出事業者データ補完
          </v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-btn
              icon
              dark
              @click="closeButtonClickEvent"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-title
          class="primary--text"
        >
          排出事業者
        </v-card-title>
        <v-card-text style="max-height: 55vh;">
          <v-data-table
            :headers="tableHeader"
            :items="transferManifests"
            :items-per-page="-1"
            fixed-header
            hide-default-footer
            disable-sort
          >
            <!-- マニフェスト: マニフェスト番号/状態 -->
            <template v-slot:[`item.manifest_no`]="{ item }">
              <div>
                {{ item.manifest_no }}
              </div>
              <div>
                <v-chip
                  :title="item.emission_situation === 'positive' ? 'マスタ紐付け済' : '紐付け未設定'"
                  label
                  x-small
                  :color="item.emission_situation === 'positive' ? 'info' : 'error'"
                >
                  {{ item.emission_situation === 'positive' ? 'マスタ紐付け済' : '紐付け未設定' }}
                </v-chip>
              </div>
            </template>
            <!-- /マニフェスト: マニフェスト番号/状態 -->

            <!-- 加入者番号 -->
            <template v-slot:[`item.jwnet_emission_subscriber_number`]="{ item }">
              <div>
                {{ item.jwnet_emission_subscriber_number }}
              </div>
            </template>
            <!-- /加入者番号 -->

            <!-- 排出事業者名/住所 -->
            <template v-slot:[`item.jwnet_emission`]="{ item }">
              <div
                class="text-ellipsis text-sm-caption"
                :title="item.jwnet_emission_name"
                style="width: 180px;"
              >{{ item.jwnet_emission_name }}</div>
              <div
                class="text-ellipsis text-sm-caption"
                :title="item.jwnet_emission_address"
                style="width: 180px;"
              >{{ item.jwnet_emission_address }}</div>
            </template>
            <!-- /排出事業者名/住所 -->

            <!-- 排出事業場名/住所 -->
            <template v-slot:[`item.jwnet_location`]="{ item }">
              <div
                class="text-ellipsis text-sm-caption"
                :title="item.jwnet_location_name"
                style="width: 180px;"
              >{{ item.jwnet_location_name }}</div>
              <div
                class="text-ellipsis text-sm-caption"
                :title="item.jwnet_location_address"
                style="width: 180px;"
              >{{ item.jwnet_location_address }}</div>
            </template>
            <!-- /排出事業場名/住所 -->

            <!-- DXE事業者コード/DXE加入者番号 -->
            <template v-slot:[`item.dxe_emission_code`]="{ item }">
              <div>
                {{ item.dxe_emission_code }}
              </div>
              <div>
                {{ item.dxe_emission_subscriber_number }}
              </div>
            </template>
            <!-- /DXE事業者コード/DXE加入者番号 -->

            <!-- DXE事業者名/住所-->
            <template v-slot:[`item.dxe_emission`]="{ item }">
              <div
                class="text-ellipsis text-sm-caption"
                :title="item.dxe_emission_name"
                style="width: 180px;"
              >{{ item.dxe_emission_name }}</div>
              <div
                class="text-ellipsis text-sm-caption"
                :title="item.dxe_emission_address"
                style="width: 180px;"
              >{{ item.dxe_emission_address }}</div>
            </template>
            <!-- /DXE事業者名/住所-->

            <template v-slot:[`item.actions`]="{ item }">
              <v-btn color="primary" small @click="selectButtonClickEvent(item)">紐付け</v-btn>&emsp;
              <v-btn color="primary" small @click="addButtonClickEvent(item)">新規追加</v-btn>
            </template>
          </v-data-table>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn @click="closeButtonClickEvent">
            閉じる
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- 排出事業者検索 -->
    <emission-search-modal
      :dialog="searchEmission"
      :target-item="selectableItem"
      :target-selectable-ids="selectableIds"
      :searched-at="searchedAt"
      :not-exist-same-number="notExistSameNumber"
      @closeCallback="closeModalCallback"
      @registerCallback="emissionSearchCallback"
    />
    <!-- /排出事業者検索 -->

    <!-- 排出事業者新規登録 -->
    <emission-add-modal
      :dialog="addEmission"
      :target-id="selectableId"
      :target-selectable-ids="selectableIds"
      :searched-at="searchedAt"
      @closeCallback="closeModalCallback"
      @registerCallback="emissionSearchCallback"
    />
    <!-- /排出事業者新規登録 -->

  </div>
</template>
